import React from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-slate-950 text-slate-400 py-12 px-4 border-t border-slate-800" data-id="element-55">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center space-y-6" data-id="element-56">
        <div className="flex flex-col md:flex-row gap-6 md:gap-12 mb-4" data-id="element-57">
          <div className="flex items-center justify-center gap-2" data-id="element-58">
            <LockIcon className="w-5 h-5 text-slate-500" data-id="element-59" />
            <span className="font-medium text-slate-300" data-id="element-60">Pago 100% seguro</span>
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-61">
            <MailIcon className="w-5 h-5 text-slate-500" data-id="element-62" />
            <span className="font-medium text-slate-300" data-id="element-63">
              Recibís todo en tu email en menos de 5 minutos
            </span>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 w-full" data-id="element-64">
          <p className="text-sm" data-id="element-65">
            © MÉTODO CALMA® — Todos los derechos reservados
          </p>
          <p className="text-xs mt-4 text-slate-600 max-w-2xl mx-auto" data-id="element-66">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}